export default "__VITE_ASSET__DOPJOfXo__"